/*
  assets/header-wishlist.js
  Keeps the header wishlist heart's count badge in sync with the
  "cgp_wishlist_v1" localStorage wishlist. Loaded site-wide (from
  snippets/header-actions.liquid) since the header appears on every
  page, unlike collection-grid-with-promos.js which only loads on
  pages using that specific section.
*/
(function () {
  var WISHLIST_KEY = 'cgp_wishlist_v1';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getCount() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      if (!raw) return 0;
      return Object.keys(JSON.parse(raw)).length;
    } catch (e) {
      return 0;
    }
  }

  function updateBadge() {
    var badge = document.querySelector('[data-cgp-header-wishlist-count]');
    if (!badge) return;

    var count = getCount();
    if (count > 0) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  ready(function () {
    updateBadge();

    // Same-tab updates (e.g. a heart was clicked on this page).
    document.addEventListener('cgp:wishlist-updated', updateBadge);

    // Cross-tab updates (wishlist changed in another tab/window).
    window.addEventListener('storage', function (e) {
      if (e.key === WISHLIST_KEY) updateBadge();
    });
  });
})();
